import { createFileRoute, redirect } from '@tanstack/react-router';

// Back-compat shim, as for `ivr/new`. There is no IVR-menu-to-flow mapping to
// follow — a flow is a separate record, not a migrated menu — so the id is
// dropped and the link lands on the Call Flows list rather than 404ing.
export const Route = createFileRoute('/_dashboard/dashboard/settings/call-settings/ivr/$id')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/call-settings', search: { tab: 'flows' } });
  },
});
